import { Dispatch, Fragment, SetStateAction, useEffect, ReactNode, useState } from 'react';
import { useLayoutContext } from '../layout/Layout';

let defaultTools: Record<string, ReactNode> = {};
let _setTools: Dispatch<SetStateAction<Record<string, ReactNode>>>;

export function TestTools({ children, id }: { children: ReactNode; id: string }) {
    const { model: { isProduction } } = useLayoutContext();

    useEffect(() => {
        if (!isProduction) {
            if (_setTools) {
                _setTools((prev) => ({ ...prev, [id]: children }));
            } else {
                defaultTools[id] = children;
            }
        }
        return () => {
            if (_setTools) {
                _setTools((prev) => ({ ...prev, [id]: undefined }));
            } else {
                delete defaultTools[id];
            }
        };
    }, [id, children, isProduction]);

    return <Fragment />;
}

export function TestToolsContainer() {
    const { model: { isProduction } } = useLayoutContext();
    const [tools, setTools] = useState<Record<string, ReactNode>>(defaultTools);
    _setTools = setTools;

    return <>{!isProduction && Object.entries(tools).map(([key, tools]) => <Fragment key={key}>{tools}</Fragment>)}</>;
}
